import Util from '@/common/UtilityFunctions.js';
import axios from 'axios';
import moment from 'moment';

export const state = {
  data: {
    welcomePage: {
      pageHeadline: 'pageHeadline',
      policeHeadline: 'policeHeadline',
      policeText: 'policeText',
      policeLink: {},
      bikeFrameNumberHeadline: 'bikeFrameNumberHeadline',
      bikeFrameNumberText: 'bikeFrameNumberText',
      insuranceHeadline: 'insuranceHeadline',
      insuranceText: 'insuranceText',
      startClaimButtonText: 'startClaimButtonText'
    },
    descriptionPage: {
      stepHeadline: 'stepHeadline',
      whoOwnsTheBikeHeadline: 'whoOwnsTheBikeHeadline',
      whoOwnsTheBikeOptions: [
        {
          label: null,
          value: 'Jeg selv eller en person i min husstand'
        },
        {
          label: null,
          value: 'Udeboende barn under 21'
        },
        {
          label: null,
          value: 'Andre'
        }
      ],
      otherOwnerNameText: 'otherOwnerNameText',
      whatHappenedHeadline: 'whatHappenedHeadline',
      whatHappenedOptions: [
        {
          label: null,
          value: 'Tyveri af cykel'
        },
        {
          label: null,
          value: 'Tyveriforsøg'
        },
        {
          label: null,
          value: 'Tyveri af cykeldele'
        }
      ],
      descriptionHeadline: 'descriptionHeadline',
      descriptionFieldDefaultText: 'descriptionFieldDefaultText',
      descriptionText: 'descriptionText',
      whenHeadline: 'whenHeadline',
      whenLabel: 'whenLabel',
      wasTheBikeLockedHeadline: 'wasTheBikeLockedHeadline',
      howWasTheBikeLockedInfoBox: 'howWasTheBikeLockedInfoBox',
      wasTheBikeLockedOptions: [
        {
          label: 'Ja',
          value: 'Ja'
        },
        {
          label: 'Nej',
          value: 'Nej'
        }
      ],
      describeHowTheBikeWasLockedText: 'describeHowTheBikeWasLockedText',
      howWasTheBikeLockedHeadline: 'howWasTheBikeLockedHeadline',
      howWasTheBikeLockedOptions: [
        {
          label: 'Med en forsikringsgodkendt l&#229;s',
          value: 'Med en forsikringsgodkendt l&#229;s',
          infoLink: null
        },
        {
          label: 'Med en anden l&#229;s',
          value: 'Med en anden l&#229;s'
        },
        {
          label: 'Cyklen var l&#229;st p&#229; en anden m&#229;de',
          value: 'Cyklen var l&#229;st p&#229; en anden m&#229;de'
        }
      ],
      memberHasBikeFrameNumberHeadline: 'memberHasBikeFrameNumberHeadline',
      memberHasBikeFrameNumberText: 'memberHasBikeFrameNumberText',
      memberHasBikeFrameNumberTooltip: 'memberHasBikeFrameNumberTooltip',
      memberHasBikeFrameNumberOptions: [
        {
          label: 'Ja',
          value: 'Ja'
        },
        {
          label: 'Jeg har ikke stelnummeret',
          value: 'Jeg har ikke stelnummeret'
        }
      ],
      memberHasBikeFrameNumberInfoBox: 'memberHasBikeFrameNumberInfoBox'
    },
    bikePage: {
      stepHeadline: 'stepHeadline',
      bikeAgeHeadline: 'bikeAgeHeadline',
      bikeAgeLabel: 'bikeAgeLabel',
      bikeAgeOptions: [
        {
          label: '0-1 år',
          value: '0-1 år'
        },
        {
          label: '1-2 år',
          value: '1-2 år'
        },
        {
          label: '2-3 år',
          value: '2-3 år'
        }
      ],
      bikeReceiptHeadline: 'bikeReceiptHeadline',
      bikeReceiptText: 'Du kan tage billede af kvitteringen og sende til os her.',
      bikeReceiptOptions: [
        {
          label: 'Ja',
          value: 'Ja'
        },
        {
          label: 'Nej jeg har ingen kvittering',
          value: 'Nej jeg har ingen kvittering'
        }
      ],
      bikeReceiptInfoBox:
        'Hvis du ikke har en kvittering, kan det p&#229;virke st&#248;rrelsen p&#229; din erstatning',
      bikeReceiptUploadSubHeadline: 'Upload kvittering',
      bikeReceiptUploadButtonText: 'bikeReceiptUploadButtonText',
      bikeReceiptUploadRemoveButtonText: 'bikeReceiptUploadRemoveButtonText',
      bikeReceiptUploadInfoBox:
        'Vi modtager n&#230;sten alle filtyper. Filst&#248;rrelsen m&#229; dog ikke overskride 64 MB.',
      bikePriceHeadline: 'bikePriceHeadline',
      bikePriceText: 'bikePriceText',
      bikePriceValidationTextOverrideMaxValue: 'bikePriceValidationTextOverrideMaxValue',
      bikePriceValidationTextOverrideMinValue: 'bikePriceValidationTextOverrideMinValue',
      bikePriceValidationTextOverrideNumeric: 'bikePriceValidationTextOverrideNumeric',
      bikePriceInfoBox:
        'Din cykel koster m&#229;ske mere i dag, end da du k&#248;bte den. Ring evt. til din cykelhandler eller s&#248;g efter din model p&#229; nettet.',
      extraBikeEquipmentHeadline: 'extraBikeEquipmentHeadline',
      extraBikeEquipmentText: 'extraBikeEquipmentText',
      extraBikeEquipmentOptions: [
        {
          label: 'Ja',
          value: 'Ja'
        },
        {
          label: 'Nej',
          value: 'Nej'
        }
      ]
    },
    equipmentPage: {
      stepHeadline: 'stepHeadline',
      equipmentAgeHeadline: 'equipmentAgeHeadline',
      equipmentAgeLabel: 'equipmentAgeLabel',
      equipmentAgeOptions: [
        {
          label: '0-1 år',
          value: '0-1 år',
          infoLink: null
        },
        {
          label: '1-2 år',
          value: '1-2 år',
          infoLink: null
        },
        {
          label: '2-3 år',
          value: '2-3 år',
          infoLink: null
        },
        {
          label: '3-4 år',
          value: '3-4 år',
          infoLink: null
        },
        {
          label: '4-5 år',
          value: '4-5 år',
          infoLink: null
        },
        {
          label: '5-6 år',
          value: '5-6 år',
          infoLink: null
        },
        {
          label: '6-7 år',
          value: '6-7 år',
          infoLink: null
        },
        {
          label: '7-8 år',
          value: '7-8 år',
          infoLink: null
        },
        {
          label: '8-9 år',
          value: '8-9 år',
          infoLink: null
        },
        {
          label: '9-10 år',
          value: '9-10 år',
          infoLink: null
        },
        {
          label: '10-11 år',
          value: '10-11 år',
          infoLink: null
        },
        {
          label: '11-12 år',
          value: '11-12 år',
          infoLink: null
        },
        {
          label: '12-13 år',
          value: '12-13 år',
          infoLink: null
        },
        {
          label: '13-14 år',
          value: '13-14 år',
          infoLink: null
        },
        {
          label: '14-15 år',
          value: '14-15 år',
          infoLink: null
        },
        {
          label: '15-16 år',
          value: '15-16 år',
          infoLink: null
        },
        {
          label: '16-17 år',
          value: '16-17 år',
          infoLink: null
        },
        {
          label: '17-18 år',
          value: '17-18 år',
          infoLink: null
        },
        {
          label: 'Mere end 18 år',
          value: 'Mere end 18 år',
          infoLink: null
        }
      ],
      equipmentNameHeadline: 'equipmentNameHeadline',
      equipmentNameLabel: 'equipmentNameLabel',
      equipmentNameOptions: [
        {
          label: 'Lygter',
          value: 'Lygter'
        },
        {
          label: 'Andet',
          value: 'Andet'
        }
      ],
      equipmentOptionalNameLabel: 'equipmentOptionalNameLabel',
      equipmentPriceHeadline: 'equipmentPriceHeadline',
      equipmentPriceLabel: 'equipmentPriceLabel',
      addMoreEquipmentButtonText: 'addMoreEquipmentButtonText',
      addedEquipmentHeadline: null,
      removeEquipmentButtonText: 'removeEquipmentButtonText',
      cancelButtonText: 'cancelButtonText',
      saveAndContinueButtonText: 'saveAndContinueButtonText'
    },
    summaryPage: {
      pageHeadline: 'pageHeadline',
      claimSummaryHeadline: 'claimSummaryHeadline',
      claimSummaryText: 'claimSummaryText',
      bikeOwnerLabel: 'bikeOwnerLabel',
      claimTypeLabel: 'claimTypeLabel',
      dateLabel: 'dateLabel',
      errorModal: {
        title: 'Der opstod en generel fejl',
        text: 'Der er opstået en fejl - ring på 33 11 77 55.',
        retryButtonLabel: 'Pr&#248;v igen',
        cancelButtonLabel: 'Afslut'
      },
      bikeFrameNumberLabel: 'bikeFrameNumberLabel',
      receiptLabel: 'receiptLabel',
      bikeAgeLabel: 'Cyklens alder',
      bikePriceLabel: 'Pris p&#229; tilsvarende cykel',
      scalepointHeadline: 'scalepointHeadline',
      requestScalepointLink: false,
      requestScalepointLinkLabel: 'Ja tak, send mig et link til Scalepoint',
      requestScalepointLinkTooltip:
        'Scalepoint er en indk&#248;bsportal, som du kan f&#229; adgang til via L&#230;rerstandens Brandforsikring. Her kan du opn&#229; gode rabatter p&#229; bl.a. cykler. N&#229;r din erstatning er opgjort, kan du v&#230;lge at f&#229; tilsendt et link med en personlig kode, som du kan bruge til at k&#248;be nye varer i Scalepoint.',
      submitButtonText: 'submitButtonText'
    },
    confirmationPage: {
      pageHeadline: 'Bekr&#230;ftelse',
      confirmationText: 'confirmationText',
      selfServiceLink: null
    },
    submitData: {
      createClaimEntity: {},
      bicycleClaimQuestionsTemplateModel: {
        whoOwnsTheBikeSelectedValue: null,
        whoOwnsTheBikeOtherName: null,
        whatHappenedSelectedValue: null,
        description: null,
        whenDate: moment(),
        bikeFrameNumber: null,
        memberHasBikeFrameNumberSelectedValue: null,
        wasTheBikeLockedSelectedValue: null,
        howWasTheBikeLockedSelectedValue: null,
        describeHowTheBikeWasLocked: null,
        bikeAgeSelectedValue: null,
        bikeReceiptSelectedValue: null,
        bikePrice: null,
        extraBikeEquipmentSelectedValue: null,
        equipment: []
      }
    },
    uploadData: {
      files: []
    }
  },
  loading: false,
  claimSubmitted: null,
  filesUploaded: null,
  modalData: {
    title: null,
    text: null,
    buttons: [
      {
        label: null,
        action: null,
        spinner: true,
        secondary: false
      },
      {
        label: null,
        action: null,
        spinner: false,
        secondary: true
      }
    ]
  },
  showModal: false,
  createdClaimId: null
};

export const actions = {
  cancel() {
    window.location.href = '/';
  },
  closeModal({ commit }) {
    commit('setShowModal', false);
  },
  async getInitialData({ commit, dispatch }) {
    const policyId = Util.getQueryVariableFromRouterUrl('id');
    commit('setLoading', true);
    await axios
      .get(Util.constants().API.bike_theft_claim_flow_initiate + '/' + policyId)
      .then((response) => {
        commit('setStateData', response.data);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setLoading', false);
        dispatch('goTo404Page');
      });
  },
  goTo404Page() {
    window.location.href = '/404';
  },
  goToSelfServicePage() {
    window.location.href = '/selvbetjening';
  },
  removeEquipmentItem({ commit }, payload) {
    commit('removeEquipmentItem', payload);
  },
  resetEquipment({ commit }, payload) {
    commit('resetEquipment', payload);
  },
  resetFiles({ commit }, payload) {
    commit('resetFiles', payload);
  },
  setBikeFrameNumber({ commit }, payload) {
    commit('setBikeFrameNumber', payload);
  },
  setDescribeHowTheBikeWasLocked({ commit }, payload) {
    commit('setDescribeHowTheBikeWasLocked', payload);
  },
  setEquipment({ commit }, payload) {
    commit('setEquipment', payload);
  },
  setFiles({ commit }, payload) {
    commit('setFiles', payload);
  },
  setHowWasTheBikeLocked({ commit }, payload) {
    commit('setHowWasTheBikeLocked', payload);
  },
  setWasTheBikeLocked({ commit }, payload) {
    commit('setWasTheBikeLocked', payload);
  },
  setWhoOwnsTheBikeOtherName({ commit }, payload) {
    commit('setWhoOwnsTheBikeOtherName', payload);
  },
  async submitClaim({ commit, state }) {
    commit('setLoading', true);
    commit('setDescriptionText');
    await axios
      .post(Util.constants().API.bike_theft_claim_flow_create, state.data.submitData)
      .then((response) => {
        const responseData = response.data.ResponseResultList[0];

        if (!responseData.IsSuccess) {
          commit('setModalData ', {
            title: responseData.FrontEndTitleMessage,
            text: responseData.FrontEndContentMessage,
            buttons: [
              {
                label: 'Prøv igen',
                action: 'bikeTheftClaimFlow/closeModal',
                spinner: false,
                secondary: false
              },
              {
                label: 'Afslut',
                action: 'bikeTheftClaimFlow/cancel',
                spinner: false,
                secondary: true
              }
            ]
          });

          commit('setShowModal', true);
        } else {
          commit('setCreatedClaimId', responseData.Data.CreatedClaimNumber);
        }

        commit('setClaimSubmitted', responseData.IsSuccess);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setModalData', {
          title: state.data.summaryPage.errorModal.title,
          text: state.data.summaryPage.errorModal.text,
          buttons: [
            {
              label: state.data.summaryPage.errorModal.retryButtonLabel,
              action: 'bikeTheftClaimFlow/closeModal',
              spinner: false,
              secondary: false
            },
            {
              label: state.data.summaryPage.errorModal.cancelButtonLabel,
              action: 'bikeTheftClaimFlow/cancel',
              spinner: false,
              secondary: true
            }
          ]
        });
        commit('setShowModal', true);
        commit('setClaimSubmitted', false);
        commit('setLoading', false);
      });
  },
  async uploadFiles({ commit, state }) {
    commit('setLoading', true);

    const formData = new FormData();

    for (let a = 0; a < state.data.uploadData.files.length; a++) {
      formData.append('files[' + a + ']', state.data.uploadData.files[a]);
    }

    formData.append('CreatedClaimId', state.createdClaimId);

    await axios
      .post(Util.constants().API.bike_theft_claim_flow_upload, formData)
      .then((response) => {
        const responseData = response.data;

        if (!responseData.IsSuccess) {
          commit('setModalData', {
            title: responseData.FrontEndTitleMessage,
            text: Util.stringTokenReplace(
              responseData.FrontEndContentMessage,
              '[ClaimNumber]',
              state.createdClaimId
            ),
            buttons: [
              {
                label: 'Afslut',
                action: 'bikeTheftClaimFlow/goToSelfServicePage',
                spinner: false,
                secondary: false
              }
            ]
          });

          commit('setShowModal', true);
        }

        commit('setFilesUploaded', responseData.IsSuccess);
        commit('setLoading', false);
      })
      .catch(() => {
        commit('setModalData', {
          title: state.data.summaryPage.uploadErrorModal.title,
          text: Util.stringTokenReplace(
            state.data.summaryPage.uploadErrorModal.text,
            '[ClaimNumber]',
            state.createdClaimId
          ),
          buttons: [
            {
              label: state.data.summaryPage.uploadErrorModal.buttonLabel,
              action: 'bikeTheftClaimFlow/goToSelfServicePage',
              spinner: false,
              secondary: false
            }
          ]
        });

        commit('setShowModal', true);
        commit('setFilesUploaded', false);
        commit('setLoading', false);
      });
  }
};

export const mutations = {
  removeEquipmentItem(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.equipment.splice(payload, 1);
  },
  resetEquipment(state) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.equipment.splice(
      0,
      state.data.submitData.bicycleClaimQuestionsTemplateModel.equipment.length
    );
  },
  resetFiles(state) {
    state.data.uploadData.files.splice(0, state.data.uploadData.files.length);
  },
  setShowModal(state, payload) {
    state.showModal = payload;
  },
  setClaimSubmitted(state, payload) {
    state.claimSubmitted = payload;
  },
  setFilesUploaded(state, payload) {
    state.filesUploaded = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setModalData(state, payload) {
    state.modalData = payload;
  },
  setDescriptionText(state) {
    const { description } = state.data.submitData.bicycleClaimQuestionsTemplateModel;

    if (description === null || description === '') {
      state.data.submitData.bicycleClaimQuestionsTemplateModel.description =
        state.data.descriptionPage.descriptionFieldDefaultText;
    }
  },
  setStateData(state, payload) {
    const whenDate = moment(payload.submitData.bicycleClaimQuestionsTemplateModel.whenDate);
    payload.submitData.bicycleClaimQuestionsTemplateModel.whenDate = whenDate;

    state.data = payload;
  },
  setCreatedClaimId(state, payload) {
    state.createdClaimId = payload;
  },

  // v-model binders
  setBikeAge(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.bikeAgeSelectedValue = payload.value;
  },
  setBikeFrameNumber(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.bikeFrameNumber = payload;
  },
  setBikePrice(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.bikePrice = payload;
  },
  setBikeReceipt(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.bikeReceiptSelectedValue = payload;
  },
  setDescribeHowTheBikeWasLocked(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.describeHowTheBikeWasLocked = payload;
  },
  setDescription(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.description = payload;
  },
  setEquipment(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.equipment.push(payload);
  },
  setExtraBikeEquipment(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.extraBikeEquipmentSelectedValue =
      payload;
  },
  setFiles(state, payload) {
    state.data.uploadData.files = payload;
  },
  setHowWasTheBikeLocked(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.howWasTheBikeLockedSelectedValue =
      payload;
  },
  setMemberHasBikeFrameNumber(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.memberHasBikeFrameNumberSelectedValue =
      payload;
  },
  setRequestScalepointLink(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.requestScalepointLink = payload;
  },
  setWasTheBikeLocked(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.wasTheBikeLockedSelectedValue =
      payload;
  },
  setWhatHappened(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.whatHappenedSelectedValue = payload;
  },
  setWhenDate(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.whenDate = payload;
  },
  setWhoOwnsTheBike(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.whoOwnsTheBikeSelectedValue = payload;
  },
  setWhoOwnsTheBikeOtherName(state, payload) {
    state.data.submitData.bicycleClaimQuestionsTemplateModel.whoOwnsTheBikeOtherName = payload;
  }
};

export const getters = {
  summaryData(state, getters) {
    const { summaryPage } = state.data;
    const { bicycleClaimQuestionsTemplateModel } = state.data.submitData;

    const whenDate = {
      label: summaryPage.dateLabel,
      value: getters.whenDateAsString
    };

    const description = {
      label: summaryPage.descriptionLabel,
      value: bicycleClaimQuestionsTemplateModel.description
    };

    const whoOwnsTheBike = {
      label: summaryPage.bikeOwnerLabel,
      value: getters.whoOwnsTheBike
    };

    const whatHappened = {
      label: summaryPage.claimTypeLabel,
      value: bicycleClaimQuestionsTemplateModel.whatHappenedSelectedValue
    };

    const bikeFrameNumber = {
      label: summaryPage.bikeFrameNumberLabel,
      value: getters.memberHasBikeFrameNumber
    };

    const wasTheBikeLocked = {
      label: summaryPage.wasTheBikeLockedLabel,
      value: bicycleClaimQuestionsTemplateModel.wasTheBikeLockedSelectedValue
    };

    const howWasTheBikeLocked = {
      label: summaryPage.howWasTheBikeLockedLabel,
      value: getters.howWasTheBikeLocked
    };

    const bikeAge = {
      label: summaryPage.bikeAgeLabel,
      value: bicycleClaimQuestionsTemplateModel.bikeAgeSelectedValue
    };

    const bikeReceipt = {
      label: summaryPage.bikeReceiptLabel,
      value: getters.bikeReceipt
    };

    const bikePrice = {
      label: summaryPage.bikePriceLabel,
      value: bicycleClaimQuestionsTemplateModel.bikePrice
    };

    const extraBikeEquipment = {
      label: summaryPage.extraBikeEquipmentLabel,
      value: getters.extraBikeEquipment
    };

    const data = [];

    data.push(whenDate);

    if (bicycleClaimQuestionsTemplateModel.description !== null) {
      data.push(description);
    }

    data.push(whoOwnsTheBike);
    data.push(whatHappened);
    data.push(bikeFrameNumber);

    if (bicycleClaimQuestionsTemplateModel.wasTheBikeLockedSelectedValue !== null) {
      data.push(wasTheBikeLocked);
    }

    if (bicycleClaimQuestionsTemplateModel.howWasTheBikeLockedSelectedValue !== null) {
      data.push(howWasTheBikeLocked);
    }

    data.push(bikeAge);
    data.push(bikeReceipt);
    data.push(bikePrice);
    data.push(extraBikeEquipment);

    return data;
  },

  // summaryData helpers
  bikeReceipt(state) {
    if (state.data.uploadData.files.length > 0) {
      const { files } = state.data.uploadData;
      let str = '';

      files.forEach((file, i) => {
        str += file.name;

        if (i < files.length - 1) {
          str += '<br />';
        }
      });

      return str;
    }

    return state.data.submitData.bicycleClaimQuestionsTemplateModel.bikeReceiptSelectedValue;
  },
  extraBikeEquipment(state) {
    if (state.data.submitData.bicycleClaimQuestionsTemplateModel.equipment.length > 0) {
      const { equipment } = state.data.submitData.bicycleClaimQuestionsTemplateModel;
      let str = '';

      equipment.forEach((item, i) => {
        str += item.name + ', ' + item.age + ', ' + item.price + ',00 kr';

        if (i < equipment.length - 1) {
          str += '<br />';
        }
      });

      return str;
    }

    return state.data.submitData.bicycleClaimQuestionsTemplateModel.extraBikeEquipmentSelectedValue;
  },
  howWasTheBikeLocked(state) {
    if (
      state.data.submitData.bicycleClaimQuestionsTemplateModel.describeHowTheBikeWasLocked !== null
    ) {
      return state.data.submitData.bicycleClaimQuestionsTemplateModel.describeHowTheBikeWasLocked;
    }

    return state.data.submitData.bicycleClaimQuestionsTemplateModel
      .howWasTheBikeLockedSelectedValue;
  },
  memberHasBikeFrameNumber(state) {
    if (state.data.submitData.bicycleClaimQuestionsTemplateModel.bikeFrameNumber !== null) {
      return state.data.submitData.bicycleClaimQuestionsTemplateModel.bikeFrameNumber;
    }

    return state.data.submitData.bicycleClaimQuestionsTemplateModel
      .memberHasBikeFrameNumberSelectedValue;
  },
  whenDateAsString(state) {
    return state.data.submitData.bicycleClaimQuestionsTemplateModel.whenDate.format('YYYY-MM-DD');
  },
  whoOwnsTheBike(state) {
    if (state.data.submitData.bicycleClaimQuestionsTemplateModel.whoOwnsTheBikeOtherName !== null) {
      return state.data.submitData.bicycleClaimQuestionsTemplateModel.whoOwnsTheBikeOtherName;
    }

    return state.data.submitData.bicycleClaimQuestionsTemplateModel.whoOwnsTheBikeSelectedValue;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
